import React, { useEffect, useRef, useState } from "react";
import "./CustomerSeatPreview.scss";

const CustomerSeatLayout = ({
  sections = [],
  selected = [],
  bookedSeats = [],
  reservations = [],
  onToggle = () => {},
  onRemove = () => {}
}) => {
  const layoutRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const resize = () => {
      const maxWidth = window.innerWidth - 40;
      const layoutWidth = layoutRef.current?.offsetWidth || 800;
      setScale(Math.min(1, maxWidth / layoutWidth));
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <div className="c-seat-preview-container">
      <div
        className="c-seating-layout"
        ref={layoutRef}
        style={{ transform: `scale(${scale})`, transformOrigin: "top center" }}
      >
        {(sections || []).map((section, sectionIdx) => (
          <div key={sectionIdx}>
            <div className="c-divider" />

            <div className="c-section-title">
              {section?.name || "Untitled Section"} (EUR {section?.price || "NoPrice"})
            </div>

            <div className="c-section-blocks-wrapper">
              {(section?.blocks || []).slice()
  .sort((a, b) => (a.block_order ?? 0) - (b.block_order ?? 0)).map((block, blockIdx) => (
                <div key={blockIdx} className="c-block">
                  <div className="c-block-title">
                    {block?.name || `Block ${blockIdx + 1}`}
                  </div>

                  <div className="c-block-rows">
                    {(block?.rows || []).slice()
  .sort((a, b) => (a.row_order ?? 0) - (b.row_order ?? 0)).map((row, rowIdx) => (
                      <div key={rowIdx} className="c-row-container">
                        <div className="c-row-title">
                          {row?.name || `Row ${rowIdx + 1}`}
                        </div>

                        <div className="c-seat-row">
                          {(row?.seats || [])
                          .slice()
                          .sort((a, b) => {
                            if (a.position != null && b.position != null) {
                              return a.position - b.position;
                            }
                            if (a.number != null && b.number != null) {
                              return Number(a.number) - Number(b.number);
                            }
                            return 0;
                          })
                          .map((seat, index) => {
                            if (seat?.status === "no_seat") {
                              return <div key={index} className="c-empty-seat" />;
                            }

                            const seatType = seat.seat_type || "available";
                            const isDouble = seatType?.seat_model === "double";
                            const disabledPersonSeat = seatType?.name === "Disabled";
                            const isSelected = selected.includes(seat.id);
                            const isBooked = bookedSeats.includes(seat.id);
                            const isDisabled = seat.status === "disabled" || isBooked;

                            const reservationMap = new Map(
                              reservations.map(r => [r.seat_id, r.booking_id])
                            );

                            const reservedSeatIds = new Set(reservations.map(r => r.seat_id));
                            const isReserved = reservedSeatIds.has(seat.id);
                            const bookingId = reservationMap.get(seat.id);

                            return (
                              <div
                                key={seat.id}
                                className={`c-seat-box
                                  ${isReserved ? "c-reserved-seat" : ""}
                                  ${isDisabled ? "c-disabled-seat" : ""}
                                  ${isBooked ? "c-booked-seat" : ""}
                                  ${isDouble ? "c-double-seat" : ""}
                                  ${isSelected ? "c-selected-seat" : ""}
                                  
                                `}
                                onClick={() => {
                                  if (isReserved) {
                                    const ok = window.confirm(
                                      `This seat is reserved (Booking #${bookingId}). Remove reservation?`
                                    );
                                    if (ok) {
                                      onRemove(bookingId, seat);
                                    }
                                  } else if (!isDisabled) {
                                    console.log("NOT RESERVED TOGGLE")
                                    onToggle(seat);
                                  }

                                }}
                                tabIndex={0}
                                role="button"
                                aria-label={`Seat ${
                                  seat.number || seat.position
                                } ${
                                  isDisabled
                                    ? "disabled"
                                    : isSelected
                                    ? "selected"
                                    : "available"
                                }`}
                                style={{
                                  ...(seat.merge_to_left && {
                                    marginLeft: 0,
                                    borderLeft: 0,
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                  }),
                                  ...(seat.merge_to_right && {
                                    marginRight: 0,
                                    borderRight: 0,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                  }),
                                }}
                              >
                                {disabledPersonSeat ? <p>🦽</p> : seat.number}
                                {seat.suffix || null}
                              </div>
                              
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerSeatLayout;
